var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-blue-400  w-full h-full rounded-full flex justify-center align-center items-center m-2"},[_c('h1',{staticClass:"text-9xl text-blue font-bold"},[_vm._v(_vm._s(_vm.number))])])}
var staticRenderFns = []

export { render, staticRenderFns }